import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getPrincipalById } from '../../utils/principal-service/principal-endpoints';
import { Principal } from '../../utils/types';

export const usePrincipalById = (
  principalId: string,
): UseQueryResult<Principal> => {
  return useQuery({
    queryFn: async () => {
      return await getPrincipalById(principalId);
    },
    queryKey: ['principalById', principalId],
    select: ({ data }) => data,
  });
};
